import "core-js/modules/es6.reflect.construct";
import _createClass from "/data/landun/workspace/vft-activities/d2d-welfare/codebase/node_modules/@babel/runtime-corejs2/helpers/esm/createClass.js";
import _classCallCheck from "/data/landun/workspace/vft-activities/d2d-welfare/codebase/node_modules/@babel/runtime-corejs2/helpers/esm/classCallCheck.js";
import _inherits from "/data/landun/workspace/vft-activities/d2d-welfare/codebase/node_modules/@babel/runtime-corejs2/helpers/esm/inherits.js";
import _possibleConstructorReturn from "/data/landun/workspace/vft-activities/d2d-welfare/codebase/node_modules/@babel/runtime-corejs2/helpers/esm/possibleConstructorReturn.js";
import _getPrototypeOf from "/data/landun/workspace/vft-activities/d2d-welfare/codebase/node_modules/@babel/runtime-corejs2/helpers/esm/getPrototypeOf.js";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import { logger } from "../../util";
import BossClient from "./boss-client";
import BossGroupClient from "./boss-group-client";
import BossReporter from "./boss-reporter";

function createReportClient(config) {
  var isArrayConfig = Array.isArray(config);

  if (isArrayConfig && config.length > 1) {
    return new BossGroupClient(config);
  }

  return new BossClient(isArrayConfig ? config[0] : config);
}
/**
 * @description 创建BossReporter中间件
 * @deprecated Boss接口即将下线，建议尽快切换至atta，并使用createAttaReporter创建实例
 * @param { IBossReportOptions } options 配置对象
 * @returns { BossReporter }
 * @example
 * ```ts
 * import reportPlugin, { createBossReporter } from '@tencent/vft-report';
 * // 单boss上报
 * Vue.use(reportPlugin, {
 *   middlewares: [
 *     createBossReporter({
 *       config: { bossId: '123456', pwd: 'xxx' },
 *     }),
 *   ],
 * });
 *
 * // 多boss上报
 * Vue.use(reportPlugin, {
 *   middlewares: [
 *     createBossReporter({
 *       config: [
 *         { bossId: '123456', pwd: 'xxx' },
 *         { bossId: '654321', pwd: 'xxx' }
 *       ],
 *     }),
 *   ],
 * });
 * ```
 */


export function createBossReporter(options) {
  logger.warn('[deprecated]Boss接口即将下线，建议尽快切换至atta，并使用createAttaReporter创建实例');
  return createReporter(options);
}
;
/**
 * @description 为了兼容原有直接new BossReporter的调用方式，需要传入options.config
 * @deprecated 建议使用createBossReporter来创建实例
 */

var BossReport = /*#__PURE__*/function (_BossReporter) {
  _inherits(BossReport, _BossReporter);

  var _super = _createSuper(BossReport);

  function BossReport(options) {
    _classCallCheck(this, BossReport);

    logger.warn('[Deprecated]use createBossReporter instead');
    var config = options.config;

    if (!config || Array.isArray(config) && config.length === 0) {
      throw new Error('[boss-report.BossReport]缺少config配置');
    }

    return _super.call(this, options, createReportClient(options.config));
  }

  return _createClass(BossReport);
}(BossReporter);
/**
 * 创建AttaReporter实例
 * @param { IAttaReportOptions } options atta配置
 * @returns { BossReporter }
 */


export { BossReport as default };
export function createAttaReporter(options) {
  return createReporter(options);
}

function createReporter(options) {
  var config = options.config;

  if (!config || Array.isArray(config) && config.length === 0) {
    throw new Error('[boss-report.createReporter]缺少config配置');
  }

  return new BossReporter(options, createReportClient(config));
}